<template>
  <v-card
      style="border: solid 4px white !important"
      class="rounded-lg px-2 py-6 elevation-0 cursor-pointer scaleHover"
      outlined
      data-aos="zoom-in"
      data-aos-easing="ease"
      data-aos-duration="500"
      data-aos-once="true"
      @click="$router.push(`/${route}`)"
    >
      <v-row dense>
        <v-col col="12">
          <h2 class="text-center primary--text">Pit Stop do Saber</h2>
          <p class="text-center">
            Pronto para testar seus conhecimentos? <strong class="secondary--text">Clique aqui</strong> para acessar a
            atividade!
          </p>
        </v-col>
      </v-row>

      <v-row justify="center" dense>
        <v-col cols="12" lg="4">
          <Lottie
            :atividade="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="1000"
            data-aos-once="true"
          />
        </v-col>
      </v-row>
    </v-card>
</template>

<script>
import Lottie from "@/components/Lottie.vue";

export default {
  props: {
    route: {
      type: String,
      required: true
    }
  },

  components: {
    Lottie,
  },
}

</script>